module.exports = __webpack_public_path__ + "static/logo-banner-cf0afe7ee6ddae35f98929e64d5408ca.svg";